import styled, { css } from 'styled-components';

const styles = css`
  // Font
`;

const Strong = styled.strong`
  ${styles}
`;
Strong.styles = styles;

export default Strong;
